import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { pipe } from 'ramda';

import { stripHtmlString, inlineEditorHtml } from '../../common/helpers/browser';
import { t } from '../../../modules/infra/i18n';

const formatHtml = pipe(inlineEditorHtml, stripHtmlString);

const getMessageTypeMap = () => ({
  sendSms: t('engage:notification.text'),
  sendPush: t('engage:notification.push'),
});

const getNotificationsText = (selected) => {
  if (isEmpty(selected)) return '';
  const messageTypeMap = getMessageTypeMap(); // ✅ t() called at runtime
  return Object.keys(selected)
    .filter(key => selected[key])
    .map(key => messageTypeMap[key])
    .join(' & ');
};

const PushNotificationPreview = ({ sendSms, sendPush, subject, text }) => {
  // Use fallback values with t() called at runtime
  const displaySubject = subject || t('engage:notification.default_subject');
  const displayText = text || t('engage:notification.default_text');
  
  return (
    <div>
      <h3 className="c-heading c-heading--tiny u-mb-">
        <span>{getNotificationsText({ sendSms, sendPush })}</span> {t('engage:notification.preview')}
        </h3>
      <div className="c-preview-frame">
        <p className="u-type--bold">{formatHtml(displaySubject)}</p>
        <p>
          {formatHtml(displayText)} <span className="c-preview-frame__link">http://getsquire.pro/123</span>
        </p>
      </div>
      <p className="u-type--light zeta u-mt--">{t('engage:notification.directs_to_web')}</p>
    </div>
  );
};

PushNotificationPreview.propTypes = {
  sendSms: PropTypes.bool,
  sendPush: PropTypes.bool,
  subject: PropTypes.string,
  text: PropTypes.string,
};
PushNotificationPreview.defaultProps = {
  sendSms: false,
  sendPush: false,
  subject: '',
  text: '',
};

export default PushNotificationPreview;
